import styled from 'styled-components';

export const ChartContainer = styled.div`
	flex: 1 1 auto;
	padding-bottom: 20px;
	padding-top: 20px;
	min-height: 0;
	width: 100%;
`;
